import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import StartPage from './components/StartPage';
import Dashboard from './components/Dashboard';
import FormViewer from './components/FormViewer';
import ThankYou from './components/ThankYou';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import Accounts from './components/Accounts';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<StartPage />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/Accounts" element={<Accounts />} />
        <Route path="/form/:userId" element={<FormViewer />} />
        <Route path="/form/:userId/:formId" element={<FormViewer />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/adminlogin" element={<AdminLogin />} />
        <Route path="/admindashboard" element={<AdminDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
